module.exports = __webpack_public_path__ + "static/media/sample-club.0e9ad950.png";